import userflow from "userflow.js";
import { Options } from "~/Types/Options";
import { UserProfileViewModel } from "~/Contexts/CurrentUserContext";

let wasInitialized = false;
let storedOptions: Options;
let storedCurrentUser: UserProfileViewModel | null;

let originalPushState = history.pushState;

const identify = () => {
    if (!storedOptions || !storedCurrentUser || !wasInitialized) {
        return;
    }

    // this is used as a display value in userflow UI so populate it with userName if the other two are blank
    let name = storedCurrentUser.userName;
    if (storedCurrentUser.firstName && storedCurrentUser.lastName) {
        name = storedCurrentUser.firstName + " " + storedCurrentUser.lastName;
    } else if (storedCurrentUser.firstName) {
        name = storedCurrentUser.firstName;
    } else if (storedCurrentUser.lastName) {
        name = storedCurrentUser.lastName;
    }

    userflow.identify(storedCurrentUser.userName, {
        name,
        email: storedCurrentUser.email,
        masterCustomerId: storedOptions.turnstile.masterCustomerId,
        organizationId: storedOptions.turnstile.organizationId,
        organizationName: storedOptions.turnstile.organizationName,
        commerceVersion: storedOptions.environment.commerceVersion,
        productId: storedOptions.turnstile.productId,
        commerceFeatures: storedOptions.userflow.features,
    });
};

history.pushState = function () {
    // @ts-ignore
    originalPushState.apply(this, arguments);

    identify();
};

export const initializeUserflow = (options: Options, currentUser: UserProfileViewModel | null) => {
    storedOptions = options;
    storedCurrentUser = currentUser;
    if (!options.userflow.token || wasInitialized) {
        return;
    }

    wasInitialized = true;

    userflow.init(options.userflow.token);
    identify();
};
